import { ResponseGridWebComponent } from './component/ResponseGridWebComponent';
import { WEB_COMPONENT_XDR_RESPONSE_GRID } from '../../webcomponents.constants';

export { ResponseGridWebComponent };

window.customElements.define(WEB_COMPONENT_XDR_RESPONSE_GRID, ResponseGridWebComponent);
